import {
  ORDER_MASTER_REQUEST,
  ORDER_MASTER_REQUEST_SUCCESS,
  ORDER_MASTER_REQUEST_FAIL,
  YGETS_ADDRESS_REQUEST,
  YGETS_ADDRESS_REQUEST_SUCCESS
} from 'constants/action-types';

const initialState = {
  data: {
    vouchers: [],
    delivery: {
      name: null,
      price: 0,
      defaultDay: null
    }
  },
  address: {
    prefectureCode: null,
    prefecture: null,
    city: null
  },
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ORDER_MASTER_REQUEST:
      return initialState;

    case ORDER_MASTER_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.payload.data
      };

    case ORDER_MASTER_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.response
      };

    case YGETS_ADDRESS_REQUEST:
      return {
        ...state,
        ...initialState.address
      };

    case YGETS_ADDRESS_REQUEST_SUCCESS:
      return {
        ...state,
        address: action.payload.data
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderAggregators/purchase.js